module.exports = __webpack_public_path__ + "static/orientation1-ec7e27e5cc309c192446e9c1fb56dded.jpg";